<template>
  <div class="helplogin">
      <div class="helpcloginCon">
        <div class="bigTitle" @click="backFn('showa')"><span></span>注册流程</div>
        <div class="smallTile" v-for="(item,index) in flowList" v-if="showa">
          <p>{{item.con}} </p>
          <img :src="item.img" v-if="item.img!=''">
        </div>
        <div class="bigTitle" @click="backFn('showb')"><span ></span>注册常见问题</div>
        <div class="helpItem">
          <div v-for="item in registerList" v-if="showb">
            <p><span></span>{{item.problem}}</p>
            <p v-for="answerTitle in item.answer"><span></span>{{answerTitle}}</p>
          </div>
        </div>
        <div class="bigTitle" @click="backFn('showc')"><span ></span>登录流程</div>
        <div v-for="(item,index) in loginList" class="smallTile" v-if="showc">
          <p>{{item.title}}</p>
           <img :src="item.img" v-if="item.img!=''">
        </div>
        <div class="bigTitle" @click="backFn('showd')"><span ></span>忘记密码</div>
        <div v-for="(item,index) in wantlist" v-if="showd" class="smallTile">
          <p>{{item.title}}</p>
          <img :src="item.img" v-if="item.img!=''">
        </div>
        <div class="bigTitle" @click="backFn('showe')"><span ></span>登录常见问题</div>
        <div class="helpItem" v-if="showe">
          <div v-for="item in loginQuestion">
            <p><span></span>{{item.problem}}</p>
            <p v-for="answerTitle in item.answer"><span></span>{{answerTitle}}</p>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      showa:false,
      showb:false,
      showc:false,
      showd:false,
      showe:false,
      flowList:[
        {
          con:'1. 访问Xcontract官网：xcontract.cn',
          img:require('../../../assets/images/helpCenter/20190412175107.png')
        },
        {
          con:'2. 点击注册',
          img:require('../../../assets/images/helpCenter/Group2.png')
        },
        {
          con:'3. 使用邮箱或者手机号注册',
          img:'',
        },
        {
          con:'4. 输入验证码',
          img:'',
        },
        {
          con:'5. 密码和确认新的密码',
          img:'',
        },
        {
          con:'6. 点击下一步',
          img:'',
        },
        {
          con:'7. 提示注册成功，并跳转至登录页',
          img:'',
        },
      ],
      registerList:[
        {
          problem:'总是提示密码格式不正确？',
          answer:['设置密码时，密码格式应满足：6-16位数字、字母的组合，字母与数字都要有，加起来在6-18位范围内。']
        },
        {
          problem:'无法接收到短信验证码？',
          answer:['检查填写的手机号是否正确并确认是本人手机号；']
        },
        {
          problem:'无法接收到邮件验证码？',
          answer:['检查填写的邮箱是否正确并确认是本人邮箱；','去邮箱的“垃圾邮件”中查找（部分邮箱可能将此类邮件设为垃圾邮件），如还是没有，请把智签的域名：xcontract.cn加入白名单后，再点击重新发送邮件验证码。']
        }
      ],
      loginList:[
        {
          title:'1. 登录页面 https://www.xcontract.cn/verification/login',
          img:require('../../../assets/images/helpCenter/20190415112817.png')
        },
        {
          title:'2. 输入手机号/邮箱',
          img:''
        },
        {
          title:'3. 输入密码',
          img:''
        },
        {
          title:'4. 输入验证码',
          img:''
        },
        {
          title:'5. 点击登录',
          img:''
        },
        {
          title:'6. 登录成功，跳转至首页',
          img:''
        },
      ],
      wantlist:[
        {
          title:'1. 登录页点击“忘记密码”',
         img:require('../../../assets/images/helpCenter/Group2343424.png')
        },
        {
          title:'2. 忘记密码页面输入注册手机号或邮箱',
          img:''
        },
        {
          title:'3. 点击获取验证码，并输入有效验证码',
          img:''
        },
        {
          title:'4. 输入密码和确认密码',
          img:''
        },
        {
          title:'5. 点击提交',
          img:''
        },
        {
          title:'6. 找回密码成功',
          img:''
        },
      ],
      loginQuestion:[
        {
          problem:'输入用户名后提示您输入的格式不对？',
          answer:['如果您的账号是手机号，请检查手机号是否正确或是否本人号码；如果您的账号是邮箱，请检查邮箱是否正确活是否本人邮箱。']
        },
        {
          problem:'提示用户名或密码错误？',
          answer:['请检查用户名是否为本人注册的账号','请重新输入密码，确保该密码与账号匹配','如果您确实忘了密码，请点击【忘记密码】进行密码找回。']
        },
        {
          problem:'登录成功后，浏览器弹出提示保存该网站账户密码，怎么处理？',
          answer:['建议点【否】，这是智签安全团队出于安全考虑给你的建议。']
        },
        {
          problem:'忘记了密码怎么办？',
          answer:['忘记登录密码，可在智签登入页面点击“忘记密码”，通过注册账号的验证码找回密码。']
        }
      ],
    }
  },
  methods:{
    backFn(flag){
      if(this[flag]==true){
        this[flag]=false;
      }else{
        this[flag]=true;
      }
    }
  }
}
</script>